<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';

export default {
  mixins: [MixedGridFiltersItemList],

  props: {
    uniqueId: {
      type: String,
      required: true,
    },
  },

  emits: ['onItemSelected'],

  methods: {
    getInputId(item) {
      return `${this.uniqueId}-${this.filter.id}-${item.value}`;
    },
  },
};
</script>

<template>
  <fieldset
    class="form-control fieldset stack stack--spacing-2"
    data-cy="mixed-grid-filter-list"
    :data-cy-filter-id="filter.id"
  >
    <div class="fieldset__fields grid gap-4">
      <div v-for="item in filter.items" :key="item.value" class="switch switch--checkbox">
        <label
          :for="getInputId(item)"
          :data-cy-filter-value="item.label"
          class="input-label switch__label checkbox-label"
        >
          <span class="input-label__text">{{ item.label }}</span>
        </label>

        <input
          :id="getInputId(item)"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :disabled="itemIsDisabled(item)"
          :checked="itemIsActive(item)"
          type="checkbox"
          :name="getInputId(item)"
          :value="item.value"
          class="switch__input"
          @change="$emit('onItemSelected', filter.id, item.value)"
        />
      </div>
    </div>
  </fieldset>
</template>
